import {
  MagnifyingGlassIcon,
  ChevronUpDownIcon,
} from "@heroicons/react/24/outline";
import { Select, Option } from "@material-tailwind/react";
import moment from "moment";

import {
  UserPlusIcon,
  ShieldExclamationIcon,
  ArrowDownIcon,
} from "@heroicons/react/24/solid";
import {
  Card,
  CardHeader,
  Input,
  Typography,
  Button,
  CardBody,
  Chip,
  CardFooter,
  IconButton,
  Tooltip,
} from "@material-tailwind/react";
import { useEffect, useState } from "react";
import { getScanData } from "../../helperFunctions/apiFunction";
import { useAuthUserToken } from "../../hooks/useAuthUserToken";
import TableSkeleton from "../../components/Loaders/TableSkeleton";
import { Link, useNavigate } from "react-router-dom";
import ExcelJS from "exceljs";
import toast from "react-hot-toast";

const TABLE_HEAD = [
  "Id",
  "Cloud",
  "Account Id",
  "Compliance",
  "Created On",
  "Status",
  "Report",
];

export default function Scan() {
  const navigate = useNavigate();
  const { refreshToken, rbac } = useAuthUserToken();
  const [templateData, setTemplateData] = useState([]);
  const [uniqueTemplateData, setUniqueTemplateData] = useState([]);
  const [isLoading, setIsLoading] = useState(null);
  const [searchBy, setSearchBy] = useState("");
  const [sortBy, setSortBy] = useState("asc");
  const [compliantStatus, setCompliantStatus] = useState("");
  const [cloudAccountId, setCloudAccountId] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [passData, setPassData] = useState({
    cloudAccountId: "",
  });

  useEffect(() => {
    getScanData(
      refreshToken,
      searchBy,
      sortBy,
      limit,
      page,
      compliantStatus,
      cloudAccountId
    ).then((data) => {
      if (data?.code === 403) {
        navigate("/403");
        toast.error(data?.message, {
          className: "text-[12px]",
        });
      }
      if (data?.code === 403) {
        navigate("/403");
        toast.error(data?.message, {
          className: "text-[12px]",
        });
      }
      if (data?.code === 440)
        toast.error(data?.message, {
          className: "text-[12px]",
        });
      setTotalPage(data?.data?.totalPages);
      setTemplateData(data?.data?.results);
      setIsLoading(false);
    });
  }, [page, limit, sortBy, searchBy, compliantStatus, cloudAccountId]);

  useEffect(() => {
    const uniqueData = templateData?.filter(
      (item, index, self) =>
        index ===
        self.findIndex((t) => t.cloudAccountId === item.cloudAccountId)
    );
    setUniqueTemplateData(uniqueData);
  }, [templateData]);

  const handleSet = (row) => {
    const updatedPassData = {
      ...passData,
      cloudAccountId: row.cloudAccountId,
      scanId: row.scanId,
    };
    // Set state and navigate
    setPassData(updatedPassData);
    navigate(`/scanReportPage`, { state: updatedPassData });
  };
  const exportToExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Scan Data");

    const headers = [
      "S.No.",
      "Id",
      "Cloud",
      "Account Id",
      "Status",
      "Compliance",
      "Created On",
    ];

    worksheet.addRow(headers);

    templateData.forEach((row, index) => {
      worksheet.addRow([
        index + 1,
        row.scanId,
        row.cloudProvider,
        row.cloudAccountId,
        row.scanStatus,
        row.scanComplianceStatus,
        row.scanCreatedOn,
      ]);
    });

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "scan_data.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    });
  };

  return (
    <div className="app-main__inner !pl-20 ">
      <Card
        className="h-full w-full rounded-3xl shadow-xl"
        style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
      >
        <CardHeader
          floated={false}
          shadow={false}
          className=" bg-transparent rounded-none !overflow-visible"
        >
          <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between md:gap-8">
            <div>
              <Typography variant="h5" color="blue-gray">
                List of Scans
              </Typography>
              <Typography color="gray" className="mt-1 font-normal">
                View all CSPM scans on monitored cloud accounts
              </Typography>
            </div>
            <div className="flex flex-row md:flex-row items-center justify-between md:items-center gap-2 md:gap-8 mt-4 md:mt-0">
              <Button
                variant="outlined"
                size="sm"
                onClick={exportToExcel}
                loading={isLoading === null ? true : false}
              >
                <ArrowDownIcon strokeWidth={2} className="h-4 w-4" />
              </Button>
              {rbac?.scanAdd ? (
                <>
                  <Link to={`/scan/createNewScan`} className="m-0 p-0">
                    <Button
                      className="flex items-center gap-3"
                      size="sm"
                      loading={isLoading === null ? true : false}
                    >
                      <UserPlusIcon strokeWidth={2} className="h-4 w-4" />
                      <span className="hidden md:inline-block">Create New</span>
                    </Button>
                  </Link>
                </>
              ) : null}
            </div>
          </div>
          <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full">
              <Select
                color="blue"
                className="!border-t-0 !border-[#b0bec5]"
                label="Select Limit"
                onChange={(event) => {
                  setLimit(event);
                  setIsLoading(null);
                }}
                value={limit}
              >
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={30}>30</Option>
                <Option value={40}>40</Option>
                <Option value={50}>50</Option>
              </Select>
              <Select
                color="purple"
                className="!border-t-0 !border-[#b0bec5]"
                label="Sort By"
                value={sortBy}
                onChange={(event) => {
                  setSortBy(event);
                  setIsLoading(null);
                }}
              >
                <Option value="asc">Ascending</Option>
                <Option value="desc">Descending</Option>
              </Select>
              <Select
                color="green"
                className="!border-t-0 !border-[#b0bec5]"
                animate={{
                  mount: { y: 0 },
                  unmount: { y: 25 },
                }}
                label="Cloud Account Id"
                onChange={(event) => {
                  setCloudAccountId(event);
                  setIsLoading(null);
                }}
                value={cloudAccountId}
              >
                <Option value="">All Data</Option>
                {uniqueTemplateData && uniqueTemplateData.length > 0 ? (
                  uniqueTemplateData.map((item, index) => (
                    <Option
                      key={`${item.cloudAccountId}-${index}`}
                      value={item.cloudAccountId}
                    >
                      {item.cloudAccountId}
                    </Option>
                  ))
                ) : (
                  <Option value="">Loading...</Option>
                )}
              </Select>
              <Select
                color="green"
                className="!border-t-0 !border-[#b0bec5]"
                animate={{
                  mount: { y: 0 },
                  unmount: { y: 25 },
                }}
                label="Compliant Status"
                value={compliantStatus}
                onChange={(event) => {
                  setCompliantStatus(event);
                  setIsLoading(null);
                }}
              >
                <Option value="">All Data</Option>
                <Option value="compliant">Compliant</Option>
                <Option value="nonCompliant">Non Compliant</Option>
              </Select>
            </div>
            <div className="w-full md:w-auto">
              <Input
                label="Search"
                className="focus:!border-black focus:!border-2 focus:!border-t-0"
                value={searchBy}
                onChange={(e) => setSearchBy(e.target.value)}
                icon={<MagnifyingGlassIcon className="h-5 w-5" />}
              />
            </div>
          </div>
        </CardHeader>
        <CardBody className="overflow-scroll px-3 p-0">
          <table className="mt-4 w-full min-w-max table-auto text-left">
            <thead>
              <tr>
                {TABLE_HEAD.map((head, index) => (
                  <th
                    key={head}
                    className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-3 transition-colors hover:bg-blue-gray-50"
                  >
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                    >
                      {head}{" "}
                      {index !== TABLE_HEAD.length - 1 && (
                        <ChevronUpDownIcon
                          strokeWidth={2}
                          className="h-4 w-4"
                        />
                      )}
                    </Typography>
                  </th>
                ))}
              </tr>
            </thead>
            {isLoading === null ? (
              <>
                <tbody>
                  <tr>
                    <td colSpan={TABLE_HEAD.length}>
                      <TableSkeleton />
                    </td>
                  </tr>
                </tbody>
              </>
            ) : (
              <>
                <tbody>
                  {isLoading === false && templateData?.length > 0 ? (
                    templateData.map(
                      (
                        {
                          scanId,
                          cloudProvider,
                          cloudAccountId,
                          scanComplianceStatus,
                          scanCreatedOn,
                          scanStatus,
                          _id,
                        },
                        index
                      ) => {
                        const isLast = index === templateData.length - 1;
                        const classes = isLast
                          ? "p-3"
                          : "p-3 border-b border-blue-gray-50";

                        return (
                          <tr key={`${scanId}-${index}`}>
                            <td className={classes}>
                              <div className="flex items-center gap-3">
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal"
                                >
                                  {scanId}
                                </Typography>
                              </div>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                {cloudProvider}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                {cloudAccountId}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <div className="w-max">
                                <Chip
                                  variant="ghost"
                                  size="sm"
                                  value={
                                    scanComplianceStatus === "compliant"
                                      ? "Compliant"
                                      : "Non Compliant"
                                  }
                                  color={
                                    scanComplianceStatus === "compliant"
                                      ? "green"
                                      : "red"
                                  }
                                />
                              </div>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                {moment(scanCreatedOn).format(
                                  "MMMM Do YYYY, h:mm:ss a"
                                )}
                              </Typography>
                            </td>

                            <td className={classes}>
                              <div className="w-max">
                                <Chip
                                  variant="ghost"
                                  size="sm"
                                  value={
                                    scanStatus === "Completed"
                                      ? "Report"
                                      : "Disabled"
                                  }
                                  disabled={
                                    scanStatus === "Completed" ? false : true
                                  }
                                  color={
                                    scanStatus === "Completed" ? "green" : "red"
                                  }
                                />
                              </div>
                            </td>
                            <td
                              className={classes}
                              onClick={() => {
                                handleSet({
                                  scanId,
                                  cloudProvider,
                                  cloudAccountId,
                                  scanComplianceStatus,
                                  scanCreatedOn,
                                  scanStatus,
                                  _id,
                                });
                              }}
                            >
                              <Tooltip
                                className="bg-blue-gray-500"
                                content="Scan Report"
                              >
                                <IconButton variant="text">
                                  <ShieldExclamationIcon className="h-4 w-4" />
                                </IconButton>
                              </Tooltip>
                            </td>
                          </tr>
                        );
                      }
                    )
                  ) : (
                    <tr>
                      <td colSpan="8">
                        <div className="flex flex-col items-center w-full">
                          <img
                            quality={100}
                            src="/assets/images/9276430.jpg"
                            className="w-[350px] mix-blend-darken"
                            alt="no-data-found"
                          />
                          <p className="text-[20px] font-medium">
                            No Data Found!
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </>
            )}
          </table>
        </CardBody>
        {isLoading === null ? null : (
          <>
            <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
              <Button
                variant="outlined"
                size="sm"
                onClick={() => {
                  setPage(page - 1);
                  setIsLoading(null);
                }}
                disabled={totalPage > 1 ? false : true}
              >
                Previous
              </Button>
              <div className="flex items-center gap-2">
                {Array.from({ length: totalPage }, (_, index) => (
                  <IconButton
                    key={index + 1}
                    variant={index + 1 === page ? "outlined" : "text"}
                    size="sm"
                    onClick={() => {
                      setPage(index + 1);
                      setIsLoading(null);
                    }}
                    disabled={totalPage > 1 ? false : true}
                  >
                    {index + 1}
                  </IconButton>
                )).reduce((acc, button, index, array) => {
                  if (
                    totalPage > 4 &&
                    (index === 1 || index === array.length - 2)
                  ) {
                    acc.push(
                      <IconButton
                        key={`ellipsis-${index}`}
                        variant="text"
                        size="sm"
                        disabled
                      >
                        ...
                      </IconButton>
                    );
                  } else {
                    acc.push(button);
                  }
                  return acc;
                }, [])}
              </div>
              <Button
                variant="outlined"
                size="sm"
                onClick={() => {
                  setPage(page + 1);
                  setIsLoading(null);
                }}
                disabled={totalPage > 1 ? false : true}
              >
                Next
              </Button>
            </CardFooter>
          </>
        )}
      </Card>
    </div>
  );
}
